import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'
import { router } from './router'

import "./index.css"

import { KBarWrapper } from "./Components/KbarWrapper"

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <KBarWrapper>
      <RouterProvider router={router} />
      {import.meta.env.DEV && <TanStackRouterDevtools router={router} />}
    </KBarWrapper>
  </StrictMode>,
)